import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"

import * as projectStyles from "./project.module.scss"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Badge from "react-bootstrap/Badge"

import DownloadOnAppStore from "./../../static/download-on-appstore.svg"
import DownloadOnPlayStore from "./../../static/google-play-badge.png"

const Project = props => {
  return (
    <Container className={projectStyles.outerContainer}>
      <Container className={projectStyles.projectContainer}>
        <Row>
          <h2 className={projectStyles.title}>{props.title}</h2>
        </Row>
        <div className={projectStyles.separator} id="separator" />

        <Row>
          <LazyLoadImage
            alt={props.alt}
            className={projectStyles.projectImage}
            image={props.image}
            src={props.image}
          />
        </Row>

        <Row>
          {props.tags &&
            props.tags.map(tag => {
              return (
                <Badge
                  variant="primary"
                  className={projectStyles.tag}
                  key={tag}
                >
                  {tag}
                </Badge>
              )
            })}
        </Row>

        <Row>
          <p className={projectStyles.date}>{props.date}</p>
        </Row>

        <Row>
          <p className={projectStyles.description}>{props.description}</p>
        </Row>

        <Row>
          {props.link && (
            <a
              className={projectStyles.link}
              href={props.link}
              target="_blank"
              rel="noopener noreferrer"
              key={props.link}
            >
              Link: {props.link}
            </a>
          )}
        </Row>

        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {props.appStoreLink && (
            <a href={props.appStoreLink}>
              <LazyLoadImage
                alt={"App Store Link"}
                className={projectStyles.appStoreLink}
                src={DownloadOnAppStore}
              />
            </a>
          )}
          {props.googlePlayLink && (
            <a href={props.googlePlayLink}>
              <LazyLoadImage
                alt={"Google Play Store Link"}
                className={projectStyles.googlePlayLink}
                src={DownloadOnPlayStore}
              />
            </a>
          )}
        </Row>
      </Container>
    </Container>
  )
}

export default Project
